import{jsx as s,jsxs as w,Fragment as B}from"react/jsx-runtime";import f,{forwardRef as R}from"react";import a,{css as h}from"styled-components";import y from"../../theme.js";import I from"../Spinner/index.js";import{BasicButtonFontStyle as j,ButtonRegularTextStyle as k}from"../../typography/ButtonText/index.js";import{fontSizes as T,smallSizeStyles as A,regularSizeStyles as C,largeSizeStyles as E,disabledColorStyles as F,colorStyles as V}from"./styles.js";import"../../utils/utils.js";const c=0,D=a.button`
  ${j}
  box-sizing: border-box;
  outline: none;
  cursor: pointer;
  user-select: none;
  position: relative;
  border: none;
  ${({$noRadius:e})=>!e&&"border-radius: 0.5rem;"}
  min-width: ${({$minWidth:e})=>e||"auto"};
  width: ${({$fullWidth:e})=>e&&"100%"};
  display: flex;
  align-items: center;
  justify-content: ${({$isIcon:e,$isLoading:i})=>!i&&e?"space-between":"center"};

  ${({$size:e})=>T[e]||k}
  ${({$size:e})=>h`
    ${e==="small"&&A()}
    ${e==="regular"&&C()}
    ${e==="large"&&E()}
  `}
  background-color: transparent;
  transition:
    color 0.3s ease,
    background-color 0.3s ease,
    border 0.3s ease,
    filter 0.3s;
  ${({$variant:e="solid",$color:i,$colorShade:t,disabled:n,theme:l})=>h`
    ${n?F(l,e):V[e]({theme:l,$color:i,$colorShade:t,$variant:e})}
  `}
  &:focus-visible {
    box-shadow: 0px 0px 0px 1px
      ${({theme:e})=>e.colors.grayscaleToned.light5};
    outline: revert;
  }
`,M={small:"1rem",regular:"1.25rem",large:"1.5rem"},b={small:"0.5rem",regular:"1rem",large:"1rem"},x=a.span`
  display: flex;
  margin-right: ${({type:e,size:i})=>e==="prefix"?b[i]:0};
  margin-left: ${({type:e,size:i})=>e==="sufix"?b[i]:0};
  font-size: ${({size:e})=>M[e]};
  opacity: ${({isLoading:e})=>e?c:1};
`,N=a(I)`
  position: absolute;
`,O=a.span`
  opacity: ${({$isLoading:e})=>e?c:1};
`,q={small:1,regular:1.25,large:1.5},u=R(({size:e="regular",color:i,colorShade:t="mainAlt",variant:n="solid",fullWidth:l=!1,isDisabled:p=!1,isLoading:o=!1,children:z,sufixIcon:d,prefixIcon:m,minWidth:S,as:$="button",noRadius:v=!1,...L},W)=>s(D,{...L,as:$,$minWidth:S,$color:i,$colorShade:t,disabled:p||o,$fullWidth:l,theme:y,$variant:n,$size:e,$isLoading:o,ref:W,$isIcon:!!(m||d),$noRadius:v,"aria-disabled":$==="button"?p||o:void 0,"aria-busy":$==="button"?o:void 0,children:w(B,{children:[m&&s(x,{size:e,type:"prefix",isLoading:o,children:m}),((r,g)=>typeof r=="string"||typeof r=="number"?s(O,{$isLoading:g,children:r}):f.isValidElement(r)?f.cloneElement(r,{style:{...r.props.style,opacity:g?c:1}}):r)(z,o),d&&s(x,{size:e,type:"sufix",isLoading:o,children:d}),o&&s(N,{customColor:y.colors.grayscaleToned.light1,size:q[e]})]})}));u.displayName="Button";export{u as Button,u as default};
